(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[327],{

/***/ 3057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function ArrowRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

module.exports = ArrowRightIcon;

/***/ }),

/***/ 953:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects",
      function () {
        return __webpack_require__(2574);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ projects; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(3057);
var ArrowRightIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightIcon);
// EXTERNAL MODULE: ./src/components/atoms/Link/index.tsx
var Link = __webpack_require__(4357);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./src/components/projectcard.tsx






function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var ProjectCard = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ProjectCard, Component);
    function ProjectCard(props) {
        _classCallCheck(this, ProjectCard);
        var _this;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(ProjectCard).call(this, props));
        _this.projectcard = /*#__PURE__*/ react.createRef();
        _this.throttleScroll = (0,lodash.throttle)(_this.handleScroll, 100);
        _this.isInViewport = function(elem) {
            var bounding = elem.getBoundingClientRect();
            return bounding.top >= 0 - bounding.height / 2 && bounding.left >= 0 && bounding.bottom - bounding.height / 2 <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
        };
        _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
        _this.state = {
            visible: false
        };
        _this.throttleScroll = _this.throttleScroll.bind(_assertThisInitialized(_this));
        return _this;
    }
    _createClass(ProjectCard, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var inView = this.isInViewport(this.projectcard.current);
                if (inView) {
                    this.setState({
                        visible: true
                    });
                } else {
                    window.addEventListener("scroll", this.throttleScroll, false);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("scroll", this.throttleScroll, false);
            }
        },
        {
            key: "handleScroll",
            value: function handleScroll() {
                var inView = this.isInViewport(this.projectcard.current);
                if (inView) {
                    this.setState({
                        visible: true
                    });
                    window.removeEventListener("scroll", this.throttleScroll, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "projectcard-" + this.props.data.slug,
                    ref: this.projectcard,
                    className: "w-full py-7",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative px-4 my-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute -top-1/4 -left-1/4 lg:-left-16 xl:-left-32",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-full",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 411 411",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                className: (0,clsx_m/* default */.Z)("a l5", this.state.visible && "stroke-dashoffset-0"),
                                                x2: "411",
                                                y2: "411",
                                                transform: "translate(50 0) rotate(" + this.props.data.rotation + " 205.5 205.5)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                className: (0,clsx_m/* default */.Z)("a l6", this.state.visible && "stroke-dashoffset-0"),
                                                x2: "207",
                                                y2: "207",
                                                transform: "translate(0 200)"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("opacity-0 transition relative p-4 sm:pl-28 rounded-b-sm", this.state.visible && "opacity-100"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-primary-main mb-12 font-bold text-3xl",
                                        children: this.props.data.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-8",
                                        children: this.props.data.summary
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "/projects/" + this.props.data.slug,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "font-bold",
                                            children: [
                                                "View Project",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightIcon_default()), {
                                                    className: "inline-block w-4 ml-1"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return ProjectCard;
}(react.Component);
/* harmony default export */ var projectcard = (ProjectCard);

// EXTERNAL MODULE: ./src/utils/mapGCMSEnum.ts
var mapGCMSEnum = __webpack_require__(4232);
;// CONCATENATED MODULE: ./src/pages/projects/index.tsx







function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++){
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
var validTags = [
    "PHP",
    "React",
    "Moodle",
    "Design"
];
var Project = function(props) {
    var router = (0,next_router.useRouter)();
    var tags = props.projects.reduce(function(prev, current) {
        return _toConsumableArray(prev).concat(_toConsumableArray(current.skills.filter(function(skill) {
            return validTags.includes(skill) && !prev.find(function(i) {
                return i.key === skill;
            });
        }).map(function(skill) {
            return {
                label: (0,mapGCMSEnum/* default */.Z)(skill),
                key: skill
            };
        })));
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "projects",
        className: "p-10 lg:p-20 xl:p-36",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap -mx-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "/projects",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "btn btn-red",
                                    children: "All"
                                })
                            }),
                            tags.map(function(tag) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: {
                                        pathname: "/projects",
                                        query: {
                                            tag: tag.key
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (0,clsx_m/* default */.Z)("btn", router.query.tag === tag.key ? "btn-red bg-primary-900" : "btn-white"),
                                        children: tag.label
                                    })
                                }, tag.key);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap -mx-4",
                    children: props.projects.map(function(project, i) {
                        if (router.query.tag && project.skills.includes(Array.isArray(router.query.tag) ? router.query.tag[0] : router.query.tag)) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(projectcard, {
                                data: project
                            }, i));
                        } else if (!router.query.tag) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(projectcard, {
                                data: project
                            }, i));
                        }
                        return "";
                    })
                })
            ]
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var projects = (Project);


/***/ }),

/***/ 4232:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var mapGCMSEnum = function(str) {
    return str.replace("_", " ");
};
/* harmony default export */ __webpack_exports__["Z"] = (mapGCMSEnum);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,774,888,179], function() { return __webpack_exec__(953); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);